import * as msal from '@azure/msal-browser';
import Debug from 'debug';

const debug = Debug('o365:msalInstance');

let msalInstance: msal.IPublicClientApplication;

export const CLIENT_ID = '5be6bfc7-5136-4d32-93bd-b38a2ca1983b';
export const AUTHORITY = 'https://login.microsoftonline.com/common/';

const createPCA = async () => {
  msalInstance = await msal.createNestablePublicClientApplication({
    auth: {
      clientId: CLIENT_ID,
      authority: AUTHORITY,
    },
  });

  await msalInstance.initialize();
};

export const getMsalInstance = async () => {
  if (!msalInstance) {
    debug('Creating MSAL instance');
    await createPCA();
  }

  return msalInstance;
};
